module.exports = __webpack_public_path__ + "media/baojing.bc1dc683.mp3";